import { StyleSheet } from '@react-pdf/renderer';

export const Styles = StyleSheet.create({
  container: {
    margin: 15,
    padding: 15,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  treatmentHeader: {
    borderColor: '#BDC3C7',
    borderRadius: 8,
    padding: 12,
    margin: 15,
    backgroundColor: '#F8F9FA',
  },
  treatmentHeaderTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#2C3E50',
    textAlign: 'center',
    marginBottom: 10,
    textTransform: 'uppercase',
    borderBottomWidth: 1,
    borderBottomColor: '#BDC3C7',
    paddingBottom: 5,
  },
  clientSection: {
    borderColor: '#BDC3C7',
    borderRadius: 8,
    padding: 12,
    marginBottom: 15,
    backgroundColor: '#ECF0F1',
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2C3E50',
    textAlign: 'center',
    marginBottom: 8,
    textTransform: 'uppercase',
    borderBottomWidth: 1,
    borderBottomColor: '#BDC3C7',
    paddingBottom: 3,
  },
  dataGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  dataColumn: {
    width: '48%',
    marginBottom: 6,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 10,
    marginBottom: 4,
    alignItems: 'center',
  },
  label: {
    fontWeight: 'bold',
    color: '#2C3E50',
    width: 80,
  },
  value: {
    fontWeight: 500,
    color: '#34495E',
    flex: 1,
  },
  odontogramSection: {
    borderColor: '#BDC3C7',
    borderRadius: 8,
    padding: 12,
    marginBottom: 15,
    backgroundColor: '#F8F9FA',
  },
  odontogramTitle: {
    fontSize: 13,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 10,
    textTransform: 'uppercase',
  },
  odontogramContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 8,
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#BDC3C7',
  },
  proceduresSection: {
    borderColor: '#BDC3C7',
    borderRadius: 8,
    padding: 12,
    marginBottom: 15,
    backgroundColor: '#F8F9FA',
  },
  proceduresTitle: {
    fontSize: 13,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 10,
    textTransform: 'uppercase',
  },
  tableContainer: {
    borderWidth: 1,
    borderColor: '#BDC3C7',
    borderRadius: 6,
    overflow: 'hidden',
  },
  rowHeader: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#34495E',
    padding: '6px 4px',
  },
  columnHeader: {
    flex: 1,
    fontSize: 9,
    fontWeight: 'bold',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  rowBody: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    padding: '4px',
    borderBottomWidth: 0.5,
    borderBottomColor: '#BDC3C7',
    backgroundColor: '#FFFFFF',
  },
  columnBody: {
    flex: 1,
    fontSize: 8,
    color: '#2C3E50',
    textAlign: 'center',
  },
  totalsSection: {
    borderWidth: 2,
    borderColor: '#BDC3C7',
    borderRadius: 8,
    padding: 12,
  },
  totalsTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 8,
    textTransform: 'uppercase',
  },
  totalsGrid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  totalRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0',
  },
  totalLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#2C3E50',
  },
  totalValue: {
    fontSize: 11,
    fontWeight: 'bold',
  },
  finalTotal: {
    borderTopWidth: 2,
    paddingTop: 8,
    marginTop: 8,
  },
  finalTotalLabel: {
    fontSize: 13,
    fontWeight: 'bold',
  },
  finalTotalValue: {
    fontSize: 13,
    fontWeight: 'bold',
  },
  validationCodeContainer: {
    marginTop: 10,
    alignItems: 'center',
  },
  validationCodeText: {
    fontSize: 10,
    textTransform: 'uppercase',
  },
});
